
import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export function useMagicLink() {
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const sendMagicLink = async (email: string) => {
    try {
      setLoading(true);
      
      // Sjekk først om brukeren allerede eksisterer
      const { data: { users }, error: checkError } = await supabase.auth.admin.listUsers({
        filter: { email }
      }).catch(() => ({ data: { users: [] }, error: null }));
      
      let result;
      
      // Hvis dette er en ny bruker, opprett konto først
      if (!users || users.length === 0) {
        try {
          // Prøv å opprette brukeren først med email_confirm=false
          const { error: signUpError } = await supabase.auth.signUp({
            email,
            password: `${Math.random().toString(36).slice(2)}${Date.now()}`, // Tilfeldig passord
            options: {
              emailRedirectTo: `${window.location.origin}/auth/callback`,
              data: {
                email_confirmed: true // Merk bruker som bekreftet
              }
            }
          });
          
          if (signUpError) {
            console.log("Kunne ikke opprette bruker:", signUpError);
          }
        } catch (createError) {
          console.log("Feil ved brukeropprettelse:", createError);
        }
      }
      
      // Send magisk lenke for innlogging
      const { error } = await supabase.auth.signInWithOtp({
        email,
        options: {
          emailRedirectTo: `${window.location.origin}/auth/callback`,
        },
      });

      if (error) {
        toast({
          variant: "destructive",
          title: "Feil ved innsending",
          description: error.message,
        });
        return false;
      }

      toast({
        title: "Magisk lenke sendt",
        description: "Sjekk e-posten din for innloggingslenken. Den er gyldig i 24 timer.",
      });
      return true;
    } catch (error) {
      console.error('Error sending magic link:', error);
      toast({
        variant: "destructive",
        title: "Systemfeil",
        description: "Kunne ikke sende magisk lenke. Prøv igjen senere.",
      });
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    sendMagicLink,
    loading
  };
}
